<template>
  <span>
    {{ $t('Lesson') }}
    <component :is="($router ? 'router-link': 'a')" :href="'/develop/lesson/' + notificationData.lessonId + '/view'" :to="'/develop/lesson/' + notificationData.lessonId + '/view'">{{ notificationData.linkText}}</component>
    {{ $t('has been submitted to you for review') }}
  </span>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'ReviewNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    }
  }
}
</script>
